import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { faqItems } from '../mock/mockData';
import { ArrowRight } from 'lucide-react';
import { SEO, buildFaqLd } from '../components/SEO';

const FAQ_JSON_LD = buildFaqLd(faqItems.map((item) => ({ question: item.question, answer: item.answer })));

export const FAQPage = () => {
  return (
    <div className="bg-white min-h-screen">
      <SEO
        title="Tez-tez verilən suallar | İDK BOKT"
        description="İstehlak krediti, qızıl krediti və avto lizinq üzrə tez-tez verilən suallar və cavablar. Müraciət, sənədlər və şərtlər haqqında."
        path="/faq"
        jsonLd={FAQ_JSON_LD}
      />
      {/* Hero */}
      <section className="bg-gradient-to-b from-blue-50 to-white pt-12 pb-8">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-xs font-semibold text-blue-700 uppercase tracking-[0.2em]">Dəstək</span>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-3 mb-4 font-serif-display">Tez-tez verilən suallar</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Kredit məhsullarımız və müraciət prosesi ilə bağlı ən çox soruşulan sualların cavabları.
          </p>
        </div>
      </section>

      {/* FAQ Accordion */}
      <section className="py-10 pb-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqItems.map((item, idx) => (
              <AccordionItem key={item.question} value={`faq-${idx}`} data-testid={`faq-item-${idx + 1}`}>
                <AccordionTrigger className="text-left text-base font-semibold text-gray-900 hover:text-blue-700 hover:no-underline py-5">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-gray-600 leading-relaxed pb-5">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 text-center bg-gray-50 border border-gray-200 rounded-2xl p-8">
            <h2 className="text-lg font-semibold text-gray-900 mb-2">Cavabını tapmadığınız sual var?</h2>
            <p className="text-sm text-gray-600 mb-5">Bizimlə əlaqə saxlayın — əməkdaşlarımız suallarınızı cavablandırmağa hazırdır.</p>
            <Link to="/elaqe">
              <Button className="bg-blue-700 hover:bg-blue-800 text-white" data-testid="faq-contact-btn">
                Bizimlə əlaqə saxla
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
